import {Column} from 'react-table'
import {columnGenerators} from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Logo',
    value: 'sponsorLogo',
  },
  {
    label: 'IMPACT PARTNER',
    value: 'sponsorNametyty',
  },
  {
    label: 'Social Media',
    value: 'SocialIcons',
  },
  {
    label: 'images',
    value: 'enimages',
  },

  {
    action: ['edit',"delete"],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export {roleColumns}
